import { render } from "./OrderRecruiter.vue?vue&type=template&id=2856c48d&ts=true"
import script from "./OrderRecruiter.vue?vue&type=script&lang=ts"
export * from "./OrderRecruiter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__